/// <amd-module name="Artifacts/Upack/redux/Actions" />
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  IDeleteActionPayload,
  IPromoteActionPayload,
  IRestoreActionPayload,
} from "Artifacts/Root/Protocols/types/ICommandActionPayloads";
import { trackActionWithCount } from "Artifacts/Root/redux/Actions";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const enum UpackActionTypes {
  Promote = "Artifacts/Upack/Promote",
  PermanentDelete = "Artifacts/Upack/PermanentDelete",
  Restore = "Artifacts/Upack/Restore",
  SoftDelete = "Artifacts/Upack/SoftDelete",
  Follow = "Artifacts/Upack/Follow",
}

export const UpackActions = {
  promote: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    viewId: string,
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<UpackActionTypes, IPromoteActionPayload>(UpackActionTypes.Promote, {
        feed,
        versions,
        viewId,
        onSuccessCallback,
      }),
      versions.length,
    ),
  permanentDelete: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<UpackActionTypes, IDeleteActionPayload>(UpackActionTypes.PermanentDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  restore: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<UpackActionTypes, IRestoreActionPayload>(UpackActionTypes.Restore, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  softDelete: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<UpackActionTypes, IDeleteActionPayload>(UpackActionTypes.SoftDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
};

export type UpackActionUnion = ActionsUnion<typeof UpackActions>;
